<template>
    <div class="message user-message">
        <div>{{ content }}</div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    content: { type: String, required: true }
});
</script>

<style lang="scss" scoped>
.message {
    padding: 10px;
    border-radius: 12px;
    font-size: 14px;
    max-width: 80%;
}

.user-message {
    margin-bottom: 10px;
    background-color: var(--color-blue);
    color: white;
    align-self: flex-end;
    border: none;
    width: fit-content;
}
</style>
